import { Box, Button, Typography } from "@mui/material";
import { Video as VideoIcon } from "lucide-react";
import VideoCallModule from "components/video/VideoCallModule";
import FlexPage from "components/layout/FlexPage";

export default ({
  handleCallEnd,
  token,
  isCallActive,
  onReJoin,
}: {
  handleCallEnd: () => void;
  token: string;
  isCallActive: boolean;
  onReJoin: () => void;
}) => {
  return (
    <FlexPage fullHeight headerPadding={false}>
      {isCallActive ? (
        <VideoCallModule
          onCallEnd={handleCallEnd}
          containerized={true}
          token={token}
        />
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
            gap: 3,
            backgroundColor: "#1a1a1a",
            color: "white",
          }}
        >
          <Typography variant="h4" gutterBottom>
            Video Call Ended
          </Typography>
          <Typography variant="body1" sx={{ mb: 3, textAlign: "center" }}>
            The video call has ended. Click below to rejoin.
          </Typography>
          <Button
            variant="contained"
            startIcon={<VideoIcon />}
            onClick={onReJoin}
            sx={{
              backgroundColor: "#4CAF50",
              "&:hover": { backgroundColor: "#45a049" },
            }}
          >
            Re-join Call
          </Button>
        </Box>
      )}
    </FlexPage>
  );
};
